import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Analysis from './containers/Analysis';
import Header from './components/Header';
import ListAnalysisProjects from './containers/ListAnalysisProjects';
import LockedProjectRoute from '../../components/LockedProjectRoute';
import { setActiveSection } from '../../data/actions';

export const SECTION_ANALYSIS = 'analysis';

class Index extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(setActiveSection(SECTION_ANALYSIS));
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setActiveSection(null));
  }

  render() {
    const { activeAnalysisSection, match } = this.props;
    return (
      <Grid centered className="grid_analysis_project">
        <Grid.Row>
          <Grid.Column width={14}>
            <Header section={activeAnalysisSection} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row key={1}>
          <Grid.Column width={14}>
            <Switch>
              <Route path={`${match.path}`} exact component={ListAnalysisProjects} />
              <LockedProjectRoute
                hasToBeLocked
                path={`${match.path}/:id(\\d+)`}
                component={Analysis}
              />
            </Switch>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withRouter(
  connect(state => ({
    activeAnalysisSection: state.analysis.section
  }))(Index)
);



// WEBPACK FOOTER //
// ./src/scenes/analysis/index.js